import NiceModal from "@ebay/nice-modal-react";
import { adminRequester } from "App";
import ButtonEclipse from "components/buttons/ButtonEclipse";
import InputEmail from "components/inputs/InputEmail";
import InputPassword from "components/inputs/InputPassword";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import WorldvapeLogo from "resources/img/logo/worldvape_logo.svg";
import { validateInputs } from "shared/utils/Utils";

function AdminLogin(props) {
  const { t } = useTranslation();
  const inputsSignIn = useRef([]);
  const navigate = useNavigate();
  const [isMounted, setMounted] = useState(false);

  const onSignInClick = () => {
    signIn();
  };
  useEffect(() => {
    setMounted(true);
  }, []);
  useEffect(() => {
    if (isMounted) {
      adminRequester.getCurrentUser(({ user }) => {
        if (user) {
          navigate(user.role === "admin" ? "/admin" : "/vendor");
        }
      });
    }
  }, [isMounted]);
  const signIn = () => {
    // let data = { userId: "", password: "" };
    validateInputs(inputsSignIn.current).then((result) => {
      if (result.isValid) {
        const userId = inputsSignIn.current[0].getValue();
        const password = inputsSignIn.current[1].getValue();
        adminRequester.Login(
          {
            email: userId,
            password: password,
          },
          (result) => {
            if (result.code === "unknown_error") {
              toast.error(t("이메일 또는 비밀번호를 확인하세요."), {
                autoClose: 1000,
                position: toast.POSITION.BOTTOM_CENTER,
              });
            } else if (result.user) {
              navigate(result.user.role === "admin" ? "/admin" : "/vendor");
              if (props.callback) {
                props.callback(true);
              }
            }
          }
        );
      } else {
        toast.error(t("pleaseCheckedLoginInfo"), {
          autoClose: 1000,
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    });
  };
  const onKeyPress = (event) => {
    if (event.keyCode === 13) {
      signIn();
    }
  };

  const buttonStyle = {
    // width: "150px",
    "--cui-btn-line-height": "23px",
    "--cui-btn-color": "black",
    backgroundColor: "white",
    color: "var(--font-color)",
  };

  return (
    <FlexChild
      width="100vw"
      height="100vh"
      padding={20}
      alignItems="center"
      justifyContent="center"
      backgroundColor={"#D5DAE3"}
    >
      <VerticalFlex
        width="100%"
        height="100%"
        alignItems="center"
        justifyContent="center"
      >
        <FlexChild
          width="70%"
          height="50%"
          // border="1px solid black"
          borderRadius={15}
          padding={"5% 10%"}
          backgroundColor="white"
        >
          <VerticalFlex gap={10}>
            <FlexChild />
            <FlexChild height={70}>
              <Center width={"80%"}>
                <img src={WorldvapeLogo} width={"100%"} />
              </Center>
            </FlexChild>
            <FlexChild />
            <FlexChild alignItems={"flex-start"} height="max-content">
              <InputEmail
                onKeyPress={onKeyPress}
                size={"lg"}
                signIn
                ref={(el) => (inputsSignIn.current[0] = el)}
                placeHolder={"아이디"}
              />
            </FlexChild>
            <FlexChild height="max-content">
              <InputPassword
                onKeyPress={onKeyPress}
                size={"lg"}
                signIn
                ref={(el) => (inputsSignIn.current[1] = el)}
                placeHolder={t("password")}
                confirmVisible={false}
              />
            </FlexChild>
            <FlexChild height="max-content">
              <HorizontalFlex justifyContent={"center"} gap={15}>
                <FlexChild height={40}>
                  <ButtonEclipse
                    fontSize={"19px"}
                    backgroundColor={"var(--main-color)"}
                    text={t("signIn")}
                    onClick={onSignInClick}
                  />
                </FlexChild>
                {/* <FlexChild height={40}>
                  <ButtonEclipse
                    fontSize={"19px"}
                    color={"black"}
                    border={"1px solid black"}
                    text={t("signUp")}
                    onClick={onSignUpClick}
                  />
                </FlexChild> */}
              </HorizontalFlex>
            </FlexChild>
            <FlexChild />
            <FlexChild />
          </VerticalFlex>
        </FlexChild>
      </VerticalFlex>
    </FlexChild>
  );
}

export default AdminLogin;
